<div class="background" [class.visible]="lightboxService.open"></div>

<i class="material-icons close" (click)="close()" *ngIf="lightboxService.open">close</i>
<i class="material-icons prev" (click)="previous()" *ngIf="lightboxService.open">navigate_before</i>
<i class="material-icons next" (click)="next()" *ngIf="lightboxService.open">navigate_next</i>

<graphic *ngIf="lightboxService.open" [src]="lightboxService.items[lightboxService.index].image" (swipeleft)="next()" (swiperight)="previous()"></graphic>

<selector [items]="lightboxService.items" [index]="lightboxService.index" (select)="setImage($event)" [class.visible]="lightboxService.open"></selector>
